import { RANDOMIZER_REDUCE_INVENTORY_ON_SHOW_LIST } from '../config/Constants';
import { buildHeaders,generateUrlApiV2,generateUrl } from '../helpers/MiddlewareHelpers';
import axios from 'axios';



const getConfigData= (hash, successCallback, catchCallback) => {
    const headers = buildHeaders();
    // const url = generateUrl('/competition/hash/'+hash);
    const url = generateUrlApiV2('/competition/hash/'+hash.replace(/\//g, "_"));
     axios.get(url,{
        method:'GET',
        crossdomain:true,
        headers:headers,
    }).then(successCallback).catch(catchCallback);
}

const playNowApiCall = (formdata,successCallback,catchCallBack)=>{
    const headers = buildHeaders();
    const url = generateUrlApiV2('/competition/'+formdata.idCompetition+'/optinRandomizer');
     axios.post(url,formdata,{
        method:'POST',
        crossdomain:true,
        headers:headers,
    }).then(successCallback).catch(catchCallBack);
}


const getLanguageApiCall = (language,successCallback,catchCallBack)=>{
    const headers = buildHeaders();
    const url = generateUrlApiV2('/locale/getLocaleData/'+language);
    axios.get(url,{
        method:'GET',
        crossdomain:true,
        headers:headers,
    }).then(successCallback).catch(catchCallBack);
}

// const fetchOfferCall  = (id,successCallback,catchCallBack)=>{
//     const headers = buildHeaders();
//     let url = generateUrlApiV2('/competition/getoffer/'+id);
//     if (RANDOMIZER_REDUCE_INVENTORY_ON_SHOW_LIST.includes(id)) {
//         url = generateUrlApiV2('/competition/getofferAndUpdateInventory/'+id);
//     }
//     axios.get(url,{
//         method:'GET',
//         crossdomain:true,
//         headers:headers,
//     }).then(successCallback).catch(catchCallBack);
// }

const fetchOfferCall = (id, formData, successCallback, catchCallBack) => {
    const headers = buildHeaders();
    let url = generateUrlApiV2('/competition/prepareOffer/' + id);

    axios.post(url, formData, {
        method: 'POST',
        crossdomain: true,
        headers: headers,
    }).then(successCallback).catch(catchCallBack);
}

const voteCall = (formdata,successCallback,catchCallBack)=>{
    const headers = buildHeaders();
    // const url = generateUrl('/vote');
    const url = generateUrlApiV2('/competition/vote');
     axios.post(url,formdata,{
        method:'POST',
        crossdomain:true,
        headers:headers,
    }).then(successCallback).catch(catchCallBack);
}

const updateInventoryAPICall = (id,param,successCallback,catchCallBack)=>{
    if (RANDOMIZER_REDUCE_INVENTORY_ON_SHOW_LIST.includes(id)) {
        return true;
    }
    const header = buildHeaders();
    const url = generateUrlApiV2('/competition/updateOfferInventory/'+id);
    axios.put(url,param,{
        method:"PUT",
        crossdomain:true,
        headers:header
    }).then(successCallback).catch(catchCallBack);
}

const markCodeRedeemedApiCall = (parameters, successCallback, catchCallback) => {

    const headers = buildHeaders();
    const url = generateUrlApiV2(`/competition/markCodeRedeemed`);
  
    axios.post(url, parameters, {
      method: 'POST',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
  }
  

const trackSessionApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

    const headers = buildHeaders();
    const url = generateUrlApiV2(`/event/${idCompetition}`);
  
    axios.post(url, parameters, {
      method: 'POST',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
  }
  
  const trackVoteApiCall = (idCompetition, parameters, successCallback, catchCallback) => {
  
    const headers = buildHeaders();
    const url = generateUrlApiV2(`/event/${idCompetition}`);
  
    axios.post(url, parameters, {
      method: 'POST',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
  }
  

  const updateOptinToVoteAPICall = (idCompetition, parameters, successCallback, catchCallback) => {
  
    const headers = buildHeaders();
    const url = generateUrlApiV2(`/competition/${idCompetition}/updateOptinToVote`);
  
    axios.put(url, parameters, {
      method: 'PUT',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
  }

  const webhookRegisterApi = (parameters, successCallback, catchCallback) => {

    const headers = buildHeaders();
    const url = generateUrlApiV2(`/competition/${parameters.idCompetition}/registerWebhook`);

    axios.post(url, parameters, {
      method: 'POST',
      crossdomain: true,
      headers: headers,
    })
      .then(successCallback)
      .catch(catchCallback);
  }

  const getGlobalScriptsForCustomerApi = (hash, successCallback, catchCallback) => {
    const headers = buildHeaders();
    const url = generateUrlApiV2(`/customer/getCodeInjectionForCustomer/${hash.replace(/\//g, "_")}`);
    axios.get(url, {
      method: 'GET',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
  }

const updateVBPInnerApi = (idCompetition, parameters, successCallback, catchCallback) => {

  const headers = buildHeaders();
  const url = generateUrlApiV2(`/competition/${idCompetition}/optinVB`);

  axios.post(url, parameters, {
    method: 'POST',
    crossdomain: true,
    headers: headers,
  })
    .then(successCallback)
    .catch(catchCallback);
}

const redeemEntryCodeApiCall = (parameters, successCallback, catchCallback) => {

    const headers = buildHeaders();
    const url = generateUrlApiV2(`/competition/redeemEntryCode`);
  
    axios.post(url, parameters, {
      method: 'POST',
      crossdomain: true,
      headers: headers
    })
      .then(successCallback)
      .catch(catchCallback);
  }

  

export {
    getConfigData,
    getLanguageApiCall,
    playNowApiCall,
    fetchOfferCall,
    voteCall,
    updateInventoryAPICall,
    trackSessionApiCall,
    trackVoteApiCall,
    updateOptinToVoteAPICall,
    markCodeRedeemedApiCall,
    webhookRegisterApi,
    getGlobalScriptsForCustomerApi,
    updateVBPInnerApi,
    redeemEntryCodeApiCall
}
